import { Link } from "react-router-dom";
import type { Topic } from "@/types/content";
import RankRow from "@/components/feature/RankRow";

interface RankSidebarProps {
  title?: string;
  topics: Topic[];
  moreTo?: string;
}

export default function RankSidebar({
  title = "热议榜单 · 实时",
  topics,
  moreTo = "/rank",
}: RankSidebarProps) {
  return (
    <aside className="rounded-lg border border-background-200 bg-background-100 p-4 md:p-5">
      <div className="flex items-center justify-between">
        <h2 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
          <i className="ri-bar-chart-grouped-line text-primary-500"></i>
          {title}
        </h2>
        <Link
          to={moreTo}
          className="whitespace-nowrap text-xs text-secondary-600 transition-colors hover:text-secondary-800"
        >
          完整榜单 <i className="ri-arrow-right-s-line"></i>
        </Link>
      </div>
      <div className="mt-3 divide-y divide-background-200">
        {topics.map((topic, idx) => (
          <RankRow key={topic.id} topic={topic} position={idx + 1} />
        ))}
      </div>
    </aside>
  );
}